export type LoginStep = "idle" | "code" | "password" | "done"

/**
 * Чистый переход состояния экрана логина клиента.
 * idle --(login ok)--> code
 * code --(needsPassword)--> password
 * code --(!needsPassword)--> done
 * password --(!needsPassword)--> done
 */
export const nextLoginStep = (
  current: LoginStep,
  event:
    | { kind: "started" }
    | { kind: "code"; needsPassword: boolean }
    | { kind: "password"; needsPassword: boolean },
): LoginStep => {
  switch (event.kind) {
    case "started":
      return "code"
    case "code":
      return event.needsPassword ? "password" : "done"
    case "password":
      return event.needsPassword ? "password" : "done"
    default:
      return current
  }
}
